// extracted by mini-css-extract-plugin
module.exports = {"editableAmount":"_7t1IPF"};